import { IconType } from "@common/declarations";

export const getItemIcon = (type: string): string => {
  switch (type.toLowerCase()) {
    case "audio":
      return IconType.VolumeUp;
    case "download":
      return IconType.Download;
    case "mixed":
      return IconType.File;
    case "quiz":
      return IconType.Puzzle;
    case "video":
      return IconType.Play;
    default:
      return "";
  }
};
